/* eslint-disable */
export default {
  DirectNumber: 'Direkt',
  MainCompanyNumber: 'Haupt',
  CompanyNumber: 'Unternehmen',
  CompanyFaxNumber: 'Fax',
  Blocked: 'Rufnummernunterdrückung',
  AdditionalCompanyNumber: 'Unternehmen',
  ForwardedCompanyNumber: 'Weitergeleitet',
  from: 'Von',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
